import axios from '@/lib/axios';
import { ImportedResource } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2630. インポート登録
 * [POST] /workspaces/:identifier/imported_resources
 */
type Props = {
  identifier: string;
  file: string;
  context: 'business_partner' | 'sales_order' | 'purchase_order';
};
const createImportedResources = (props: Props): Promise<ImportedResource> => {
  return axios.post(`/api/workspaces/${props.identifier}/imported_resources`, props);
};

export const useCreateImportedResources = () => {
  return useMutation({
    mutationFn: createImportedResources,
  });
};
